import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

function EmailItem({ data }) {
    const { originator } = data;
    const originatorTitle = originator && originator.channelName;
    const originatorContent = originator && originator.originator;

    return (
        <div className="history-item">
            <div className="history-item-content">
                <div className="history-title-text">
                    <i className="icon-envelope" /> {originatorTitle}: </div>
                <span className="history-content-text">{originatorContent}</span>
            </div>
        </div>
    );
}

EmailItem.propTypes = {
    data: PropTypes.object,
};

export default EmailItem;
